import { Theme } from '@mui/material/styles'

import { surfaceHover } from '../hover'

// ----------------------------------------------------------------------
// An accordion summary is the widest pressable on a form screen — one edit
// page here carries ten of them, stacked — and MUI ships it with no hover at
// all. It takes the surface answer, like every other pressable row.
//
// A disabled summary states its own rest, at a weight the answer cannot reach.
// `.Mui-disabled` on its own is the same weight as `:hover`, so which of the
// two painted a disabled summary under the pointer would come down to source
// order and to nothing a reader of this file can see.
// ----------------------------------------------------------------------

export default function Accordion(theme: Theme) {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&.Mui-expanded': {
            boxShadow: theme.customShadows.z8,
            borderRadius: theme.shape.borderRadius,
          },
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          'paddingLeft': theme.spacing(2),
          'paddingRight': theme.spacing(1),
          ...surfaceHover(theme),
          '&.Mui-disabled:hover': {
            backgroundColor: 'transparent',
          },
          '&.Mui-disabled': {
            'opacity': 1,
            'color': theme.palette.action.disabled,
            '& .MuiTypography-root': {
              color: 'inherit',
            },
          },
        },
        expandIconWrapper: {
          color: 'inherit',
        },
      },
    },
  }
}
